import useStatusHistory from "../../service/useStatusHistory";
import { useState } from "react";

export default function CardKelas(props) {
  const [open, setOpen] = useState(false);
  const { statusShort, statusRender } = useStatusHistory(props);

  return (
    <div className="flex h-full w-full flex-col space-y-3 rounded-lg border p-5 shadow-md">
      <p className="font-nunito text-lg font-semibold">
        Kelas : {props.ch_name}{" "}
        {!props.class_name ||
        props.class_name === "-" ||
        props.class_name === ""
          ? ""
          : `- ${props.class_name}`}
      </p>
      <p className="font-nunito text-lg font-semibold">
        Status :{" "}
        <span className={`${props.status === 3 ? "text-red-600" : ""}`}>
          {!open && statusShort(props.status)}
        </span>
      </p>
      {open && statusRender(props.status)}
      <div className="items-center justify-center text-center">
        {open ? (
          <div className="cursor-pointer" onClick={() => setOpen(!open)}>
            <p className="font-nunito text-lg font-semibold opacity-70 hover:opacity-100">
              Tutup detail status
            </p>
          </div>
        ) : (
          <div className="cursor-pointer" onClick={() => setOpen(!open)}>
            <p className="font-nunito text-lg font-semibold opacity-70 hover:opacity-100">
              Buka detail status
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
